/**
 * A surface tab's own surface treatment.
 *
 * Three states, and the interesting one is the third: a disabled tab that is
 * *also* active must not dim, because dimming the tab you are looking at reads
 * as the panel being broken rather than the surface being unavailable. That
 * rule was a `&&` chain inside a `cn()` call, where it could only be checked by
 * rendering the whole shell.
 */
export function surfaceTabSurfaceClass(state: {
  readonly active: boolean;
  readonly disabled: boolean;
}): string {
  if (state.active) return "bg-muted/80 text-foreground";
  const base = "text-muted-foreground hover:bg-muted/50 hover:text-foreground";
  return state.disabled ? `${base} opacity-40 hover:bg-transparent` : base;
}
